import type { Attribute, CartEntry, Price, Product } from '@maestro/data-layer'

import { buildPrice } from '@maestro/commerce-blocks/utils/price.utils'

export function addClientSideEntry(
  product: Product,
  variantId: string,
  id: string
): CartEntry {
  let variantAttributes: Attribute[] = []
  if (product.variants.length > 1) {
    const productVariant = product.variants.find((item) => item.id == variantId)
    if (productVariant) {
      variantAttributes = productVariant.attributes
    }
  }
  return {
    id,
    urlPath: product.urlPath,
    productId: product.id,
    variantId,
    productName: product.name,
    image: product.image,
    quantity: 1,
    priceBase: product.price,
    price: product.price,
    attributes: variantAttributes,
    stock: [product.stock],
    properties: {},
  } as CartEntry
}

export function buildPriceForCartEntry(
  currency: string,
  quantity: number,
  centAmount: number,
  discountedAmount?: number | undefined,
  memberAmount?: number | undefined
): Price {
  const totalCentAmount = centAmount * quantity
  const totalDiscountedCentAmount = discountedAmount
    ? discountedAmount * 100 * quantity
    : undefined
  const totalMemberCentAmount = memberAmount
    ? memberAmount * 100 * quantity
    : undefined
  const finalPrice =
    totalMemberCentAmount ?? totalDiscountedCentAmount ?? totalCentAmount

  return buildPrice(
    currency,
    finalPrice,
    totalDiscountedCentAmount,
    undefined,
    totalMemberCentAmount
  )
}
